
<div class="flex justify-content-center align-items-center w-full" style="height: 50vh" *ngIf="!loaded">
    <p-progressSpinner ariaLabel="loading" />
</div>
<div class="flex h-full" *ngIf="loaded">
    <div style="padding: 1rem; width: 100%;">
        <div class="flex flex-column justify-content-center" style="text-align: center;" *ngIf="!editMode">
            <div class="flex align-items-center justify-content-center" >
                <label class="font-bold text-xl">{{selectedModule.order}}. {{selectedModule.title}}</label>
                <p-button  icon="pi pi-pencil" pTooltip="Editar Módulo" text (onClick)="editMode=true;"></p-button>
            </div>
            <span class="text-medium"><i>{{selectedModule.description}}</i></span>
        </div>

        <div class="flex flex-column align-items-center gap-2" *ngIf="editMode">
            <div class="flex gap-2">
                <div class="flex flex-column gap-1">
                    <span class="font-bold">Ordem</span>
                    <input
                        pInputText
                        type="number"
                        style="max-width:5rem;"
                        [(ngModel)]="editedModule.order" />
                </div>

                <div class="flex flex-column gap-1">
                    <span class="font-bold">Título</span>
                    <input 
                        pInputText 
                        style="width: 20vw;"
                        type="text" 
                        [(ngModel)]="editedModule.title" />
                </div>
            </div>

            <div class="flex flex-column gap-1">
                <span class="font-bold">Descrição</span>
                <textarea pInputTextarea rows="3" [(ngModel)]="editedModule.description" style="resize: none; width: 25vw;" class="py-2 h-full"></textarea>
            </div>

            <div class="flex gap-2">
                <p-button outlined icon="pi pi-times" label="Cancelar" severity="danger" (onClick)="CancelEdit()"></p-button>
                <p-button outlined icon="pi pi-check" label="Salvar" severity="success" (onClick)="EditModule()"></p-button>
            </div>
        </div>

        <hr>

        <div class="flex flex-column justify-content-center" style=" padding: 1rem;" [@slideInOut] *ngIf="!showDialogLessonDetails" >
            <div class="flex justify-content-between">
                <label class="font-bold text-xl">Aulas cadastradas</label>
                <div>
                    <p-button label="Nova Aula" icon="pi pi-plus" (onClick)="createLesson.toggle($event)"></p-button>
                    <p-overlayPanel #createLesson>
                        <div class="flex justify-content-center align-items-center w-full" style="height: 20vh" *ngIf="addingLesson">
                            <p-progressSpinner ariaLabel="loading" />
                        </div>
            
                        <div class="flex flex-column gap-3" *ngIf="!addingLesson">
                            <label class="font-semibold text-lg mb-2">Adicionar Aula</label>
                            <div class="flex flex-column" style="gap:1.3rem">
                                <p-floatLabel>
                                    <input 
                                        pInputText 
                                        style="width: 100%;"
                                        type="text" 
                                        [(ngModel)]="newLesson.title" />
                                    <label for="">Título</label>
                                </p-floatLabel>
                                <p-floatLabel>
                                    <textarea pInputTextarea rows="3" [(ngModel)]="newLesson.description" style="resize: none; width: 20vw" class="py-2 h-full"></textarea>
                                    <label for="">Descrição</label>
                                </p-floatLabel>
                            </div>
                            <div class="w-full flex justify-content-end">
                                <button pButton label="Criar Aula" (click)="AddLesson()"></button>
                            </div>
                        </div>
                    </p-overlayPanel>
                </div>
            </div>

           <div *ngIf="listLessons.length>0"
                class="flex flex-column lessons"
                cdkDropList
                cdkDropListOrientation="vertical"
                (cdkDropListDropped)="ChangeLessonOrder($event)"
                [cdkDropListData]="listLessons"
                >
                <div *ngFor="let lesson of listLessons" cdkDrag [cdkDragData]="lesson"  style="width:70%">
                    <div class="card lessonCard p-0"  (click)="ShowDialogLessonDetails(lesson)">
                        <div class="flex justify-content-between">
                            <p-tag [value]="'Ordem: ' + lesson.order" [style]="{margin:'0.5rem'}" [rounded]="true" />
                            <p-button icon="pi pi-trash" severity="danger" text (onClick)="ConfirmDeleteLesson($event, lesson)"></p-button>
                        </div>
                        <div class="flex flex-row justify-content-between align-items-start gap-2" style="width: 100%; text-align: center;">
                            <div style="width: 100%; margin-bottom: 1rem;">
                                <div class="text-xl font-medium text-900">{{ lesson.title }}</div>
                                <span class="font-medium text-secondary text-sm">{{ lesson.description }}</span>
                            </div>
                        </div>
                    </div>
                </div>
           </div>

           <div class="card p-3" style="margin:1rem; height: 30vh; display: flex;text-align: center;width: 100%;justify-content: center;align-items: center;flex-direction: column;" *ngIf="listLessons && listLessons.length==0">
                <div>
                    <ng-lottie [options]="animationNotFound"  width="12vw" height="12vw"/>
                </div>
                <h4 style="color:#ccc;" class="mt-0">
                    <i>
                        Nenhuma aula cadastrada
                    </i>
                </h4>
            </div>
        </div>

        <div [@slideInOut] *ngIf="showDialogLessonDetails">
            <div class="flex justify-content-center align-items-center w-full" style="height: 50vh" *ngIf="requestingMaterials">
                <p-progressSpinner ariaLabel="loading" />
            </div>

            <div class="flex flex-column gap-3" *ngIf="!requestingMaterials" >
                <div class="card mb-0 lessonCard p-0" style="cursor: auto;">
                    <div class="flex justify-content-between">
                        <p-tag [value]="'Ordem: ' + selectedLesson.order" [style]="{margin:'0.5rem'}" [rounded]="true" />
                        <p-button icon="pi pi-trash" severity="danger" text></p-button>
                    </div>
                    <div class="flex flex-row justify-content-between align-items-start gap-2" style="width: 100%; text-align: center;">
                        <div style="width: 100%; margin-bottom: 1rem;">
                            <div class="text-xl font-medium text-900">{{ selectedLesson.title }}</div>
                            <span class="font-medium text-secondary text-sm">{{ selectedLesson.description }}</span>
                        </div>
                    </div>
                </div>

                <div class="flex" style="flex-direction: column;" *ngIf="!requestingMaterials">
                    <p-table 
                    #dt
                    styleClass="p-datatable-gridlines p-datatable-striped" 
                    [value]="selectedLesson.materials" 
                    [scrollable]="true"
                    [globalFilterFields]="['name']"
                    scrollHeight="40vh">
                        <ng-template pTemplate="caption">
                            <div class="text-900 text-xl font-semibold flex" style="justify-content: space-between;width:100%; ">
                                <div class="flex justify-content-between align-items-center gap-3">
                                    <div>
                                        Materiais da Aula
                                    </div>

                                    <input 
                                        pInputText 
                                        type="text" 
                                        style="height:2.5rem"
                                        (input)="onGlobalFilter($event, dt)"
                                        placeholder="Buscar Arquivo" />
                                </div>
                                <div class="flex gap-2">
                                    <p-fileUpload
                                        chooseIcon="pi pi-youtube"
                                        pTooltip="Adicionar Video"
                                        tooltipPosition="bottom"
                                        mode="basic"
                                        name="vido[]"
                                        accept=".mp4"
                                        [multiple]="false"
                                        [auto]="true"
                                        (onSelect)="uploadVideo($event)"
                                        [disabled]="isUploading"
                                        [style]="{'background': 'transparent', 'color':'var(--red-600)', 'border-color':'var(--red-600)'}">
                                    </p-fileUpload>
                                    <p-button
                                        icon="pi pi-youtube"
                                        pTooltip="Adicionar link do YouTube"
                                        tooltipPosition="bottom"
                                        severity="danger"
                                        outlined
                                        [disabled]="isUploading"
                                        (onClick)="youtubePanel.toggle($event)">
                                    </p-button>
                                    <p-overlayPanel #youtubePanel>
                                        <div class="flex flex-column gap-3" style="min-width: 22vw;">
                                            <label class="font-semibold text-lg">Adicionar link do YouTube</label>
                                            <p-floatLabel>
                                                <input
                                                    pInputText
                                                    style="width: 100%;"
                                                    type="text"
                                                    [(ngModel)]="youtubeUrl" />
                                                <label for="">Link do YouTube</label>
                                            </p-floatLabel>
                                            <div class="w-full flex justify-content-end">
                                                <button pButton label="Salvar" [disabled]="isUploading" (click)="setYoutubeVideo(youtubePanel)"></button>
                                            </div>
                                        </div>
                                    </p-overlayPanel>
                                    <p-fileUpload
                                        chooseIcon="pi pi-upload"
                                        pTooltip="Adicionar Material"
                                        tooltipPosition="bottom"
                                        mode="basic"
                                        name="documentos[]"
                                        accept=".pdf"
                                        [multiple]="false"
                                        [auto]="true"
                                        (onSelect)="uploadMaterial($event)"
                                        [disabled]="isUploading"
                                        [style]="{'background': 'transparent', 'color':'blue'}">
                                    </p-fileUpload>
                                </div>
                            </div>
                        </ng-template>
                        
                        <ng-template pTemplate="body" let-file>
                            <tr >
                                <td [pTooltip]="file.name" tooltipPosition="top">
                                    <div class="flex align-items-center gap-4" >
                                        <i class="pi pi-file"></i>
                                        <span>{{ file.name.slice(0, 20) }} <span *ngIf="file.name.length > 20">...</span></span>
                                    </div>
                                </td>
                                <td>
                                    <span>{{file.size}} kb</span>
                                </td>
                                <td class="flex">
                                    <button pButton pRipple icon="pi pi-window-maximize" pTooltip="Abrir em outra guia" tooltipPosition="bottom" class="p-button-info p-button-text p-button-rounded" (click)="openInNewTab(file.url)"></button>
                                    <!-- AINDA NÃO TEM <button pButton pRipple icon="pi pi-download" [loading]="downloading" pTooltip="Download" tooltipPosition="bottom" class="p-button-warning p-button-text p-button-rounded" (click)="downloadFile(file)"></button> -->
                                    <!-- AINDA NÃO TEM <button pButton pRipple icon="pi pi-trash" pTooltip="Excluir" tooltipPosition="bottom" class="p-button-danger p-button-text p-button-rounded" (click)="confirmDelete($event, file)"></button>  -->
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <div  style="height: 30vh; display: flex;text-align: center;width: 100%;justify-content: center;align-items: center;flex-direction: column;" *ngIf="selectedLesson.materials && selectedLesson.materials.length==0">
                                <div>
                                    <ng-lottie [options]="animationNotFound"  width="12vw" height="12vw"/>
                                </div>
                                <h4 style="color:#ccc;" class="mt-0">
                                    <i>
                                        Nenhum material encontrado
                                    </i>
                                </h4>
                            </div>
                        </ng-template>
                    </p-table>
                    <div style="margin-top: 2rem;">
                        <app-video-player [lessonId]="selectedLesson.id" *ngIf=" selectedLesson && selectedLesson.id" ></app-video-player>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>